import * as AccommodationContent from 'components/accommodation-content/accommodation-content.js'
import * as AccommodationsSlider from 'components/accommodations-slider/accommodations-slider.js'
import * as Breadcrumbs from 'components/breadcrumbs/breadcrumbs.js'
import * as ContactsContent from 'components/contacts-content/contacts-content.js'
import * as FaqContent from 'components/faq-content/faq-content.js'
import * as FaqList from 'components/faq-list/faq-list.js'
import * as Footer from 'components/footer/footer.js'
import * as FullImage from 'components/full-image/full-image.js'
import * as FullSlider from 'components/full-slider/full-slider.js'
import * as HomePackages from 'components/home-packages/home-packages.js'
import * as InfoBoxes from 'components/info-boxes/info-boxes.js'
import * as LatestPosts from 'components/latest-posts/latest-posts.js'
import * as NewsletterBar from 'components/newsletter-bar/newsletter-bar.js'
import * as MobileMenu from 'components/mobile-menu/mobile-menu.js'
import * as OffersSlider from 'components/offers-slider/offers-slider.js'
import * as OneColumn from 'components/one-column/one-column.js'
import * as PackageContent from 'components/package-content/package-content.js'
import * as PackagesBox from 'components/packages-box/packages-box.js'
import * as PackagesGrid from 'components/packages-grid/packages-grid.js'
import * as PackagesSlider from 'components/packages-slider/packages-slider.js'
import * as PageHeader from 'components/page-header/page-header.js'
import * as PageSidebar from 'components/page-sidebar/page-sidebar.js'
import * as PostContent from 'components/post-content/post-content.js'
import * as PostsList from 'components/posts-list/posts-list.js'
import * as RoomContent from 'components/room-content/room-content.js'
import * as RoomsSlider from 'components/rooms-slider/rooms-slider.js'
import * as ServicesContent from 'components/services-content/services-content.js'
import * as Socials from 'components/socials/socials.js'
import * as TwoColumns from 'components/two-columns/two-columns.js'
import * as TopPage from 'components/top-page/top-page.js'
import * as ZoneBoxes from 'components/zone-boxes/zone-boxes.js'
import * as ZonesGrid from 'components/zones-grid/zones-grid.js'

export function importComponent (name) {
    if (name === 'accommodation-content') {
        return Promise.resolve(AccommodationContent)
    }

    if (name === 'accommodations-slider') {
        return Promise.resolve(AccommodationsSlider)
    }

    if (name === 'faq-list') {
        return Promise.resolve(FaqList)
    }

    if (name === 'footer') {
        return Promise.resolve(Footer)
    }

    if (name === 'full-slider') {
        return Promise.resolve(FullSlider)
    }

    if (name === 'info-bar') {
        return Promise.resolve(FullSlider)
    }

    if (name === 'page-header') {
        return Promise.resolve(PageHeader)
    }

    if (name === 'mobile-menu') {
        return Promise.resolve(MobileMenu)
    }

    if (name === 'offers-slider') {
        return Promise.resolve(OffersSlider)
    }

    if (name === 'packages-box') {
        return Promise.resolve(PackagesBox)
    }

    if (name === 'package-content') {
        return Promise.resolve(PackageContent)
    }

    if (name === 'home-packages') {
        return Promise.resolve(HomePackages)
    }

    if (name === 'room-content') {
        return Promise.resolve(RoomContent)
    }

    if (name === 'rooms-slider') {
        return Promise.resolve(RoomsSlider)
    }

    if (name === 'packages-slider') {
        return Promise.resolve(PackagesSlider)
    }

    if (name === 'services-content') {
        return Promise.resolve(ServicesContent)
    }

    if (name === 'socials') {
        return Promise.resolve(Socials)
    }
}

import 'components/info-bar/info-bar.scss'
import 'components/featured-boxes/featured-boxes.scss'


// WEBPACK FOOTER //
// ./app/theme/components/index.js